import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reset-password-dialog',
  templateUrl: './reset-password-dialog.component.html',
  styleUrls: ['./reset-password-dialog.component.scss']
})
export class ResetPasswordDialogComponent implements OnInit {
  hide = true;
  constructor() { }

  ngOnInit() {
  }

}
